module.exports = __webpack_public_path__ + "img/Unicorn.c78c099e.png";